import styled from "styled-components";
import useCounselList from "features/teacher/hooks/counsel/useCounselList";
import { useLocation, useNavigate } from "react-router-dom";
import { hw, scrollbar } from "features/homework/homeworkUi";

const StudentCounselManage = () => {
    const student_uid = useLocation().state;
    const navigate = useNavigate();
    const { list } = useCounselList(student_uid);

    return (
        <Container>
            <Head>
                <div>
                    <Title>상담 목록</Title>
                    <Desc>이 원생의 상담 기록입니다.</Desc>
                </div>
                <Back type="button" onClick={() => navigate(-1)}>돌아가기</Back>
            </Head>
            <TableWrap>
                <TableHeader>
                    <Col $basis="22%">일자</Col>
                    <Col $basis="39%">상담내용</Col>
                    <Col $basis="39%">조치내용</Col>
                </TableHeader>
                <TableBody>
                    {list.length === 0 ? (
                        <Empty>상담 기록이 없습니다.</Empty>
                    ) : (
                        list.map((counsel, index) => (
                            <Row key={index + 1}>
                                <Col $basis="22%" $muted>{counsel.counsel_date}</Col>
                                <Col $basis="39%">{counsel.counsel_detail}</Col>
                                <Col $basis="39%">{counsel.action_detail}</Col>
                            </Row>
                        ))
                    )}
                </TableBody>
            </TableWrap>
        </Container>
    );
};

const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 14px;
    flex: 1;
    min-height: 0;
    padding: 18px 20px;
    border-radius: 16px;
    background: ${hw.surface};
    border: 1px solid ${hw.border};
    box-shadow: ${hw.shadow};
`;

const Head = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    gap: 12px;
    flex-shrink: 0;
`;

const Title = styled.h2`
    margin: 0;
    color: ${hw.text};
    font-size: 16px;
    font-weight: 700;
    letter-spacing: -0.02em;
`;

const Desc = styled.p`
    margin: 4px 0 0;
    font-size: 13px;
    color: ${hw.textMuted};
`;

const Back = styled.button`
    appearance: none;
    border: 1px solid ${hw.border};
    background: ${hw.surface};
    color: ${hw.textMuted};
    font-size: 13px;
    font-weight: 600;
    border-radius: 8px;
    padding: 8px 12px;
    cursor: pointer;

    &:hover {
        background: ${hw.bg};
        color: ${hw.text};
    }
`;

const TableWrap = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
    border: 1px solid ${hw.border};
    border-radius: 12px;
    overflow: hidden;
`;

const TableHeader = styled.div`
    display: flex;
    background: #FAFBFC;
    border-bottom: 1px solid ${hw.border};
    flex-shrink: 0;
`;

const TableBody = styled.div`
    flex: 1;
    min-height: 0;
    overflow: auto;
    ${scrollbar}
`;

const Row = styled.div`
    display: flex;
    border-bottom: 1px solid ${hw.border};

    &:nth-child(even) {
        background: #FCFCFD;
    }

    &:hover {
        background: ${hw.brandSoft};
    }
`;

const Col = styled.div<{ $basis: string; $muted?: boolean }>`
    flex-basis: ${props => props.$basis};
    padding: 12px 14px;
    font-size: 13px;
    line-height: 1.5;
    color: ${props => props.$muted ? hw.textMuted : hw.text};
    font-weight: ${props => props.$muted ? 600 : 500};
`;

const Empty = styled.div`
    padding: 48px 16px;
    text-align: center;
    color: ${hw.textSubtle};
    font-size: 13px;
`;

export default StudentCounselManage;
